import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
    copy(event) {
        if (event && event.target) {
            let link;
            if (!(event.target instanceof HTMLAnchorElement)) {
                link = event.target.closest('a');
                console.log('NOT Instance');
            }
            else {
                link = event.target;
                console.log('instance');
            }
            if (link && link.dataset && link.dataset.copyHref) {
                navigator.clipboard.writeText(link.dataset.copyHref).then(() => {
                    /* clipboard successfully set */
                    console.log('success');
                    alert("A link has been copied to your clipboard. Please paste this into an email, whatsapp, txt etc. and send to other passengers");
                }, () => {
                    /* clipboard write failed */
                    console.log('fail');
                });
            }
        }
    }
}
